import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "b-available-member-popup" }
const _hoisted_2 = { class: "b-available-member-popup__inner h-text-center" }
const _hoisted_3 = { class: "h-flex h-flex-center" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 0,
  class: "h-mt-30 h-width-100p h-font-18 h-fw-700 h-ph-20 h-text-center"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "h-flex h-flex-dir-column h-flex-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FwIcon = _resolveComponent("FwIcon")!
  const _component_FwSpinLoader = _resolveComponent("FwSpinLoader")!
  const _component_FwButton = _resolveComponent("FwButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_FwIcon, {
        class: "b-available-member-popup__inner__icon",
        icon: "close",
        size: "15",
        color: "#BEC7D4",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit("backToPreview")))
      }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: _ctx.requireImage("member-available-img.svg")
        }, null, 8, _hoisted_4)
      ]),
      (_ctx.isLoading || _ctx.isMembersNotAvailable)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_ctx.isLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createTextVNode(_toDisplayString(_ctx.$t('MEMBERS.CHECKING.AVAILABILITY')) + " ", 1),
                  (_ctx.isLoading)
                    ? (_openBlock(), _createBlock(_component_FwSpinLoader, {
                        key: 0,
                        style: {"position":"relative"},
                        colors: ["#27dbbd", "#27DBBD", "#27DBBD"],
                        class: "b-global-loading h-pos-rel b-global-loading--transparent",
                        isActive: _ctx.isLoading,
                        className: "h-p-20"
                      }, null, 8, ["isActive"]))
                    : _createCommentVNode("", true)
                ]))
              : (_ctx.isMembersNotAvailable)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createTextVNode(_toDisplayString(_ctx.$t('MEMBERS.CHECKING.AVAILABILITY.FAILED')) + " ", 1),
                    _createVNode(_component_FwButton, {
                      class: "h-mt-30 h-width-250 qa-remove-alone",
                      borderRadiusType: "small-border",
                      color: "alert",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit("backToPreview")))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('BUTTON.CANCEL')), 1)
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}